var StepType;
(function (StepType) {
    StepType[StepType["Start"] = 0] = "Start";
    StepType[StepType["Departments"] = 1] = "Departments";
    StepType[StepType["Users"] = 2] = "Users";
    StepType[StepType["ExpenseCategories"] = 3] = "ExpenseCategories";
    StepType[StepType["FiltrationOfCategories"] = 4] = "FiltrationOfCategories";
    StepType[StepType["CompanyPolicy"] = 5] = "CompanyPolicy";
    StepType[StepType["GeneralLedgerDimensions"] = 6] = "GeneralLedgerDimensions";
    StepType[StepType["EmployeeDimensions"] = 7] = "EmployeeDimensions";
    StepType[StepType["EmployeeMapping"] = 8] = "EmployeeMapping";
    StepType[StepType["ExpenseReportDimensions"] = 9] = "ExpenseReportDimensions";
    StepType[StepType["Review"] = 10] = "Review";
})(StepType || (StepType = {}));
var QuickSetupStatus;
(function (QuickSetupStatus) {
    QuickSetupStatus[QuickSetupStatus["NotStarted"] = 0] = "NotStarted";
    QuickSetupStatus[QuickSetupStatus["Started"] = 1] = "Started";
    QuickSetupStatus[QuickSetupStatus["Pending"] = 2] = "Pending";
    QuickSetupStatus[QuickSetupStatus["Error"] = 3] = "Error";
    QuickSetupStatus[QuickSetupStatus["Completed"] = 4] = "Completed";
})(QuickSetupStatus || (QuickSetupStatus = {}));
export { QuickSetupStatus, StepType };
